import {Component, Input, Output, EventEmitter, ViewChild, ElementRef, Inject} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {AnnouncementFormInt} from 'app/components/dashboard/admin/interfaces/announcement';

@Component({
    selector: 'announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.scss']
})

export class AnnouncementForm {

    constructor() {}

    ngOnInit(): void {
        this.Form  = new FormGroup({});
    }

    @ViewChild('baseGroup', {static: false}) baseGroup: ElementRef;

    @Input() disabled = false;
    @Input() edited = false;

    public model: AnnouncementFormInt;
    public Form: FormGroup;

    @Input() get announcement() {
        return this.model;
    }

    @Output() announcementChange = new EventEmitter();

    set announcement(val) {
        this.Form  = new FormGroup({});
        this.model = val;
        this.announcementChange.emit(this.model);
    }
}
